"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _CreateReminder = _interopRequireDefault(require("../model/CreateReminder"));
var _UpdateReminder = _interopRequireDefault(require("../model/UpdateReminder"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
* Reminders service.
* @module api/RemindersApi
* @version 0.1.0
*/
var RemindersApi = /*#__PURE__*/function () {
  /**
  * Constructs a new RemindersApi. 
  * @alias module:api/RemindersApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function RemindersApi(apiClient) {
    _classCallCheck(this, RemindersApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * @param {Object} opts Optional parameters
   * @param {module:model/CreateReminder} opts.createReminder Payload for creating a new reminder.
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
   */
  _createClass(RemindersApi, [{
    key: "createWithHttpInfo",
    value: function createWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['createReminder'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/reminders/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CreateReminder} opts.createReminder Payload for creating a new reminder.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "create",
    value: function create(opts) {
      return this.createWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getWithHttpInfo",
    value: function getWithHttpInfo(id) {
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling get");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/reminders/{id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "get",
    value: function get(id) {
      return this.getWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page Page of results to return.
     * @param {Number} opts.limit Limit of results to return.
     * @param {String} opts.orderBy Ordering of the result set; reminderTime, siteName, userName, id or created
     * @param {String} opts.order Direction of the ordering; asc or desc - defaults to desc.
     * @param {String} opts.start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {String} opts.end The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
     * @param {Number} opts.creatorId ID of the creator user to filter by.
     * @param {Number} opts.userId ID of the subject user to filter by.
     * @param {Number} opts.contactId ID of the contact user to filter by.
     * @param {Number} opts.siteId ID of a site to filter by.
     * @param {Number} opts.faultId ID of a fault to filter by.
     * @param {Array.<Number>} opts.statuses List of statuses to filter by.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "searchWithHttpInfo",
    value: function searchWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'page': opts['page'],
        'limit': opts['limit'],
        'orderBy': opts['orderBy'],
        'order': opts['order'],
        'start': opts['start'],
        'end': opts['end'],
        'creatorId': opts['creatorId'],
        'userId': opts['userId'],
        'contactId': opts['contactId'],
        'siteId': opts['siteId'],
        'faultId': opts['faultId'],
        'statuses': this.apiClient.buildCollectionParam(opts['statuses'], 'multi')
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/reminders/', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page Page of results to return.
     * @param {Number} opts.limit Limit of results to return.
     * @param {String} opts.orderBy Ordering of the result set; reminderTime, siteName, userName, id or created
     * @param {String} opts.order Direction of the ordering; asc or desc - defaults to desc.
     * @param {String} opts.start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {String} opts.end The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
     * @param {Number} opts.creatorId ID of the creator user to filter by.
     * @param {Number} opts.userId ID of the subject user to filter by.
     * @param {Number} opts.contactId ID of the contact user to filter by.
     * @param {Number} opts.siteId ID of a site to filter by.
     * @param {Number} opts.faultId ID of a fault to filter by.
     * @param {Array.<Number>} opts.statuses List of statuses to filter by.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "search",
    value: function search(opts) {
      return this.searchWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/UpdateReminder} opts.updateReminder Payload for updating an existing reminder.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "updateWithHttpInfo",
    value: function updateWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = opts['updateReminder'];
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling update");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/reminders/{id}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/UpdateReminder} opts.updateReminder Payload for updating an existing reminder.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "update",
    value: function update(id, opts) {
      return this.updateWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
  return RemindersApi;
}();
exports["default"] = RemindersApi;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@solarschools/api-sdk/dist/api/RemindersApi.js
// module id = 6WWf
// module chunks = 3